var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { xrService } from "../../modules/xr/XRService";
import { busService } from "../../modules/bus";
import { ToastMessage } from "flavr-common";
import { VrToastMessage } from "../../messages/xr/WebXRMessages";
import i18next from "i18next";
import { localizationService } from "../../modules/localization/LocalizationService";
export var MessageService;
(function (MessageService) {
    let globalShowError;
    let globalShowToast;
    function registerGlobalShowErrorFn(fn) {
        if (globalShowError !== undefined)
            console.warn("[ui] globalShowError is already defined");
        globalShowError = fn;
    }
    MessageService.registerGlobalShowErrorFn = registerGlobalShowErrorFn;
    function registerGlobalShowToastFn(fn) {
        if (globalShowToast !== undefined)
            console.warn("[ui] globalShowToast is already defined");
        globalShowToast = fn;
    }
    MessageService.registerGlobalShowToastFn = registerGlobalShowToastFn;
    function showMessage(severity, message, timeToShowInMs, color, messageID) {
        switch (severity) {
            case "success":
            case "info":
                console.log(`[showMessage] ${message}`);
                break;
            case "warn":
                console.warn(`[showMessage] ${message}`);
                break;
            case "error":
                console.error(`[showMessage] ${message}`);
                break;
        }
        if (xrService.isPresenting()) {
            busService.connection("MessageService").send(new VrToastMessage(message, timeToShowInMs, color, messageID));
        }
        else {
            if (severity === "info" || severity === "success") {
                if (globalShowToast !== undefined) {
                    globalShowToast(message, severity, timeToShowInMs, color, messageID);
                }
                else {
                    console.error("[ui] globalShowToast is not defined");
                }
            }
            else {
                if (globalShowError !== undefined) {
                    globalShowError(message, severity, timeToShowInMs, color, messageID);
                }
                else {
                    console.error("[ui] globalShowError is not defined");
                }
            }
        }
    }
    MessageService.showMessage = showMessage;
    function getMessageIconName(severity) {
        switch (severity) {
            case "info":
                return "info-circle";
            case "success":
                return "check-circle";
            case "error":
                return "times-circle";
            case "warn":
                return "exclamation-triangle";
        }
    }
    MessageService.getMessageIconName = getMessageIconName;
    let globalShowStartTraining;
    function registerGlobalStartTrainingFn(fn) {
        if (globalShowStartTraining !== undefined)
            console.warn("[ui] globalShowStartTraining is already defined");
        globalShowStartTraining = fn;
    }
    MessageService.registerGlobalStartTrainingFn = registerGlobalStartTrainingFn;
    function showStartTraining(trainingName, inputConfig, onStart, onCancel) {
        return __awaiter(this, void 0, void 0, function* () {
            if (globalShowStartTraining !== undefined) {
                globalShowStartTraining(trainingName, inputConfig, onStart, onCancel !== null && onCancel !== void 0 ? onCancel : (() => { }));
            }
            else {
                console.error("[ui] globalShowStartTraining is not defined");
                yield Promise.reject(new Error("globalShowStartTraining is not defined"));
            }
        });
    }
    MessageService.showStartTraining = showStartTraining;
    let globalShowEndTraining;
    function registerGlobalEndTrainingFn(fn) {
        if (globalShowStartTraining !== undefined)
            console.debug("[ui] globalShowEndTraining is already defined. This can happen when using hot module replacement.");
        globalShowEndTraining = fn;
    }
    MessageService.registerGlobalEndTrainingFn = registerGlobalEndTrainingFn;
    function showEndTraining(trainingName, trainingResults, onEnd, onRestart, onRevisitErrors) {
        return __awaiter(this, void 0, void 0, function* () {
            if (globalShowEndTraining !== undefined) {
                globalShowEndTraining(trainingName, trainingResults, onEnd, onRestart !== null && onRestart !== void 0 ? onRestart : (() => { }), onRevisitErrors !== null && onRevisitErrors !== void 0 ? onRevisitErrors : (() => { }));
            }
            else {
                console.error("[ui] globalShowStartTraining is not defined");
                yield Promise.reject(new Error("globalShowEndTraining is not defined"));
            }
        });
    }
    MessageService.showEndTraining = showEndTraining;
    let globalShowConfirmation;
    function registerGlobalConfirmationFn(fn) {
        if (globalShowConfirmation !== undefined)
            console.warn("[ui] globalShowConfirmation is already defined");
        globalShowConfirmation = fn;
    }
    MessageService.registerGlobalConfirmationFn = registerGlobalConfirmationFn;
    function showConfirmation(question, yesText, noText, onConfirm, onReject) {
        return __awaiter(this, void 0, void 0, function* () {
            if (globalShowConfirmation !== undefined) {
                globalShowConfirmation(question, yesText, noText, onConfirm, onReject !== null && onReject !== void 0 ? onReject : (() => { }));
            }
            else {
                console.error("[ui] globalShowConfirmation is not defined");
                yield Promise.reject(new Error("globalShowConfirmation is not defined"));
            }
        });
    }
    MessageService.showConfirmation = showConfirmation;
    function buttonTextCancel() {
        return i18next.t("common:message-dialog-answer-cancel", "Cancel");
    }
    function showConfirmationYesNo(question, onConfirm, onReject) {
        return __awaiter(this, void 0, void 0, function* () {
            yield showConfirmation(question, i18next.t("common:message-dialog-answer-yes", "Yes"), i18next.t("common:message-dialog-answer-no", "No"), onConfirm, onReject);
        });
    }
    MessageService.showConfirmationYesNo = showConfirmationYesNo;
    function showConfirmationOkCancel(question, onConfirm, onReject) {
        return __awaiter(this, void 0, void 0, function* () {
            yield showConfirmation(question, i18next.t("common:message-dialog-answer-ok", "Ok"), buttonTextCancel(), onConfirm, onReject);
        });
    }
    MessageService.showConfirmationOkCancel = showConfirmationOkCancel;
    function showConfirmationDelete(question, onConfirm, onReject) {
        return __awaiter(this, void 0, void 0, function* () {
            yield showConfirmation(question, i18next.t("common:message-dialog-answer-delete", "Delete"), buttonTextCancel(), onConfirm, onReject);
        });
    }
    MessageService.showConfirmationDelete = showConfirmationDelete;
})(MessageService || (MessageService = {}));
busService.connection("MessageService").subscribeByType(ToastMessage, (msg) => {
    MessageService.showMessage(msg.severity, localizationService.getTranslation(msg.message));
});
